import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { PARTNER_GROUP_CONFIG } from './base/partner-group-config';

export const partnerGroupRoutes: Routes = [
  {
    path: PARTNER_GROUP_CONFIG.routePath,
    canActivate: [roleGuard('ADMIN_MASTER')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/partner-group-list-page/partner-group-list-page.component'
          ).then((m) => m.PartnerGroupListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/partner-group-detail-page/partner-group-detail-page.component'
              ).then((m) => m.PartnerGroupDetailPageComponent),
          },
        ],
      },
    ],
  },
];
